module.exports = __webpack_public_path__ + "static/media/applejuice.f701623b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/applejuice.png
// module id = 108
// module chunks = 0